export const generateSlug = (name) => {
  return name
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, "") // Remove non-alphanumeric except spaces/hyphens
    .replace(/\s+/g, "-"); // Replace spaces with hyphens
};
